import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

import ACL_RELATIONSHIPS from "acl-relationships";
import { Button } from "@/components/ui/button";
import Authorized from "components/Authorized";
import { getNextQueryParams } from "components/helpers";
import BaseTableV3 from "components/BaseTableV3/BaseTableV3";
import {
  invalidateEmailExemptionsQuery,
  useEmailExemptionsTable,
} from "hooks/useEmailExemptionsTable";
import EmailExemptionService from "services/EmailExemptions";

export const EMAIL_EXEMPTIONS_TABLE_CONSTANTS = {
  tableName: "email_exemptions",
  queryKey: "email-exemptions",
  exportTableName: null,
  className: "EmailExemption",
  header: "Email Exemptions",
  headerIcon: "unlock",
};

const CREATE_ACLS = [
  ACL_RELATIONSHIPS.emailExemption.read,
  ACL_RELATIONSHIPS.emailExemption.create,
];

const EmailExemptionsTableV3 = () => {
  const navigate = useNavigate();
  const { columns } = useEmailExemptionsTable();

  const fetchEmailExemptions = useCallback(
    async queryParams => {
      try {
        const nextQueryParams = getNextQueryParams(queryParams, columns);

        const response =
          await EmailExemptionService.getEmailExemptions(nextQueryParams);

        return response;
      } catch (error) {
        console.error("Error fetching email exemptions:", error);
        throw error;
      }
    },
    [columns]
  );

  return (
    <BaseTableV3
      columns={columns}
      queryKey={EMAIL_EXEMPTIONS_TABLE_CONSTANTS.queryKey}
      tableName={EMAIL_EXEMPTIONS_TABLE_CONSTANTS.tableName}
      header={EMAIL_EXEMPTIONS_TABLE_CONSTANTS.header}
      headerIcon={EMAIL_EXEMPTIONS_TABLE_CONSTANTS.headerIcon}
      enableSettings
      enableSearch
      createButton={
        <Authorized permissions={CREATE_ACLS}>
          <Button
            size="sm"
            onClick={() => navigate("/settings/email_exemptions/new")}
          >
            New Email Exemption
          </Button>
        </Authorized>
      }
      fetchData={fetchEmailExemptions}
      invalidateData={invalidateEmailExemptionsQuery}
    />
  );
};

export default EmailExemptionsTableV3;
